import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AfricaIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM6.72727 3C6.63747 3 6.54882 3.01945 6.46786 3.05691L5.04969 3.71305C4.90549 3.77976 4.79487 3.89926 4.74236 4.045L4.03328 6.01344C3.95627 6.22723 4.01543 6.46472 4.18473 6.62138L5.6029 7.93365C5.71461 8.03703 5.8634 8.09474 6.01818 8.09474H7.19516L8.25453 9.075V13.421C8.25453 13.653 8.39801 13.8626 8.61912 13.9536C8.84024 14.0446 9.0963 13.9994 9.2698 13.8389L9.97889 13.1828C10.0385 13.1277 10.0856 13.0613 10.1174 12.9878L10.8858 11.2102L11.973 10.6513C12.1363 10.5674 12.2503 10.4154 12.282 10.2395L12.9911 6.30265C13.0416 6.02225 12.8734 5.74802 12.5944 5.6558L10.7808 5.05646L9.33113 3.22727C9.21761 3.08402 9.0414 3 8.85452 3H6.72727Z"
		/>
	</svg>
))
